import React from 'react'
import PropTypes from 'prop-types'

import {
  Flights,
  Hotels,
  Cars,
  Cruises,
  Restaurant,
  Beach,
  Coupon,
  Gps,
  Globe,
  Document,
  Bag,
  Discount,
  Email,
  Help,
} from 'pcln-icons'

const IconMap = {
  flights: Flights,
  hotels: Hotels,
  cars: Cars,
  cruises: Cruises,
  restaurant: Restaurant,
  beach: Beach,
  coupon: Coupon,
  gps: Gps,
  globe: Globe,
  document: Document,
  bag: Bag,
  discount: Discount,
  email: Email,
  help: Help,
}

const IconSet = ({ iconName, ...props }) => {
  const lowercaseName = iconName.toLowerCase()
  const Icon = IconMap[lowercaseName]

  return Icon ? <Icon {...props} /> : null
}

IconSet.propTypes = {
  iconName: PropTypes.string,
}

export default IconSet
